Namespace 'Monitoring.Reports.Competition'

class Monitoring.Reports.Competition.ReportView extends Backbone.View
  template: JST['backbone/templates/monitoring/reports/competition/report_view']

  events:
    'click #filter-toggle'    : '_toggleFilter'
    'click #compare-accounts' : 'onCompareAccounts'


  initialize:(@options={}) ->
    @filter_data = @options.data
    @target = @options.network
    @account_id = @options.account_id
    @selected_accounts = []

  render: ->
    @$el.html(@template)
    @socialAccountFilter = new Monitoring.Reports.Competition.SocialAccountFilterView({channels: @filter_data})
    @socialAccountFilter.render()
    @$el.find('#social-accounts-selector').html(@socialAccountFilter.el)
    return this

  renderComparisonTable: (response) =>
    @socialAccountFilter._toggleFilter()
    result = new Monitoring.Reports.Competition.CompareResultsView({selected: @selected_accounts, response: response})
    result.render()
    @$el.find('#social-accounts-results').html(result.el)

  onCompareAccounts: =>
    @$el.find('#competition-report #compare-accounts').prop('disabled', true)
    sa_ids = _.map @$el.find('input[type="checkbox"]:checked.social-account-checkbox'), (checkbox) -> checkbox.getAttribute('id')
    from = @_dateWithZone(@$el.find('#from_datepicker').datepicker('getDate').toDateString())
    to = @_dateWithZone(@$el.find('#to_datepicker').datepicker('getDate').toDateString())
    only_published_posts = @$el.find('#only_published_posts')[0].checked
    if @_validParameters sa_ids, from, to
      params = {
        social_accounts: sa_ids,
        from: from,
        to: to,
        account_id: @account_id,
        only_published_posts: only_published_posts
      }
      @_setSelectedAccounts(sa_ids)
      @_doCompare params
    else
      error_msg  = ""
      error_msg += "#{I18n.t('monitoring.competition.report.invalid_date')}" unless @_validDates(from, to)
      error_msg += "\n#{I18n.t('monitoring.competition.report.no_ids_selected')}" unless @_validIds(sa_ids)
      swal({
        title: I18n.t('monitoring.competition.report.params_error'),
        text: error_msg,
        type: "error",
        showCancelButton: false,
        confirmButtonClass: 'btn-info',
        confirmButtonText: 'Ok',
        closeOnConfirm: true
      })
    @$el.find('#competition-report #compare-accounts').prop('disabled', false)

  _doCompare: (params) =>
    @$el.find('#social-accounts-results').empty()
    @$el.find('#social-accounts-results').addClass('processing')
    $('#compare-accounts').addClass('disabled')
    $.get "/monitoring/reports/competition/#{@target}_compare", params, (response) =>
      $('#compare-accounts').removeClass('disabled')
      @$el.find('#social-accounts-results').removeClass('processing')
      return @renderComparisonTable(response) if response.status == 'success'
      errorMessage = response.message
      window.showError(errorMessage)
    @eventAggregator.trigger('monitoring:competition:compare')


  _setSelectedAccounts: (ids)  =>
    @selected_accounts = _.filter @filter_data, (data) -> data.fb_id in ids

  _validParameters: (ids, from, to) ->
    @_validIds(ids) && @_validDates(from,to)

  _validIds: (ids) ->
    ids.length > 0

  _validDates: (from, to) ->
    from < to

  _dateWithZone: (dateStr) =>
    zone = @$el.find('#timezone_selector select').val()
    Date.create("#{dateStr} #{zone}").toISOString()
